import React from 'react';

export function restrictInput(pattern: RegExp): React.KeyboardEventHandler {
    return (event: React.KeyboardEvent) => {
        if (!pattern.test(event.key)) {
            event.preventDefault();
        }
    };
}
